export enum UserFamilyType {
  Granted = "granted",
  Owner = "owner",
  NoFamily = "no-family"
}
